import React from 'react';
import svgPaths from "../imports/svg-7idtezfct7";

export function EmptyStateView({ onUpload, onStartCreating }: { onUpload: () => void; onStartCreating: () => void }) {
  return (
    <div className="absolute content-stretch flex flex-col gap-[24px] items-center left-1/2 top-1/2 translate-x-[-50%] translate-y-[-50%]">
      <div className="content-stretch flex flex-col gap-[12px] items-center relative shrink-0">
        <div className="relative shrink-0 size-[111px]" data-name="Title=No favorites; Cololr=purple; Fill=gradient;">
          <div className="absolute h-[92.692px] left-[6.73px] top-[15.1px] w-[89.757px]" data-name="background">
            <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 90 93">
              <g id="background">
                <circle cx="51.523" cy="51.0875" fill="var(--fill-0, #E4E7EC)" id="Ellipse 5" r="38.2339" />
                <circle cx="8.71428" cy="40.3036" fill="var(--fill-0, #E4E7EC)" id="Ellipse 4" r="8.71428" />
                <circle cx="25.4894" cy="5.44644" fill="var(--fill-0, #E4E7EC)" id="Ellipse 3" r="5.44643" />
                <circle cx="85.509" cy="12.5268" fill="var(--fill-0, #E4E7EC)" id="Ellipse 2" r="4.24821" />
                <circle cx="84.2016" cy="76.3589" fill="var(--fill-0, #E4E7EC)" id="Ellipse 1" r="2.06964" />
                <path d={svgPaths.p1fc73800} fill="var(--fill-0, #D0D5DD)" id="Star 1" />
                <path d={svgPaths.p10e5c0f0} fill="var(--fill-0, #D0D5DD)" id="Star 2" />
                <path d={svgPaths.pf4dfa40} fill="var(--fill-0, #D0D5DD)" id="Star 3" />
              </g>
            </svg>
          </div>
          <div className="absolute contents left-[11.73px] top-[25.92px]" data-name="illustration">
            <div className="absolute contents left-[60.54px] top-[37.32px]" data-name="tag 2">
              <div className="absolute flex h-[57.42px] items-center justify-center left-[60.54px] top-[37.32px] w-[40.809px]" style={{ "--transform-inner-width": "0", "--transform-inner-height": "0" } as React.CSSProperties}>
                <div className="flex-none rotate-[10.848deg]">
                  <div className="h-[52.427px] relative w-[31.505px]">
                    <div className="absolute inset-[0_0_1.3%_0]">
                      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 32 52">
                        <path d={svgPaths.p2b005980} fill="var(--fill-0, #D0D5DD)" id="Vector 2" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div className="absolute flex h-[15.794px] items-center justify-center left-[74.04px] top-[49.52px] w-[17.011px]" style={{ "--transform-inner-width": "0", "--transform-inner-height": "0" } as React.CSSProperties}>
                <div className="flex-none rotate-[12.059deg]">
                  <div className="h-[13.029px] relative w-[14.612px]">
                    <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 15 14">
                      <path d={svgPaths.p2a61380} fill="var(--fill-0, white)" id="Vector 1" />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="absolute left-[75.35px] size-[5.664px] top-[78.93px]" data-name="Ellipse">
                <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 6 6">
                  <circle cx="2.83214" cy="2.83214" fill="var(--fill-0, #E4E7EC)" id="Ellipse" r="2.83214" />
                </svg>
              </div>
            </div>
            <div className="absolute contents left-[11.73px] top-[25.92px]" data-name="tag 1">
              <div className="absolute flex h-[80.313px] items-center justify-center left-[11.73px] top-[25.92px] w-[63.525px]" style={{ "--transform-inner-width": "0", "--transform-inner-height": "0" } as React.CSSProperties}>
                <div className="flex-none rotate-[340.089deg]">
                  <div className="h-[70.15px] relative w-[42.155px]">
                    <div className="absolute inset-[-1.24%_-2.07%_-0.27%_-2.07%]">
                      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 44 72">
                        <path d={svgPaths.p32f24200} fill="var(--fill-0, #F0F2F5)" id="Vector 2" stroke="var(--stroke-0, #D0D5DD)" strokeWidth="0.871428" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div className="absolute flex h-[26.616px] items-center justify-center left-[25.68px] top-[41.46px] w-[27.98px]" style={{ "--transform-inner-width": "0", "--transform-inner-height": "0" } as React.CSSProperties}>
                <div className="flex-none rotate-[338.575deg]">
                  <div className="h-[19.854px] relative w-[22.266px]">
                    <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 23 20">
                      <path d={svgPaths.p220b2480} fill="var(--fill-0, #D0D5DD)" id="Vector 1" stroke="var(--stroke-0, #D0D5DD)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="0.881822" />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="absolute left-[48.12px] size-[7.189px] top-[82.41px]" data-name="Ellipse">
                <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 8 8">
                  <circle cx="3.59464" cy="3.59464" fill="var(--fill-0, #D0D5DD)" id="Ellipse" r="3.59464" />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div className="content-stretch flex flex-col gap-[10px] items-center justify-center leading-[0] relative shrink-0 text-nowrap">
          <div className="flex flex-col font-sans font-bold justify-center relative shrink-0 text-[#101928] text-[18px]" style={{ fontVariationSettings: "'opsz' 14, 'wdth' 100" }}>
            <p className="leading-[normal] text-nowrap">Your creative space is empty… for now!</p>
          </div>
          <div className="flex flex-col font-sans font-normal justify-center relative shrink-0 text-[#475367] text-[14px]" style={{ fontVariationSettings: "'opsz' 14, 'wdth' 100" }}>
            <p className="leading-[normal] text-nowrap">Start designing or upload files - everything you create will show up here</p>
          </div>
        </div>
      </div>
      <div className="content-stretch flex gap-[16px] items-start relative shrink-0">
        <div 
          className="content-stretch flex gap-[4px] h-[36px] items-center justify-center p-[12px] relative rounded-[6px] shrink-0 cursor-pointer hover:bg-gray-50 transition-colors" 
          data-name="Primary - Sm"
          onClick={onUpload}
        >
          <div aria-hidden="true" className="absolute border border-[#d0d5dd] border-solid inset-0 pointer-events-none rounded-[6px]" />
          <p className="font-sans font-medium leading-[normal] relative shrink-0 text-[#101928] text-[14px] text-nowrap" style={{ fontVariationSettings: "'opsz' 14, 'wdth' 100" }}>
            Upload Files
          </p>
        </div>
        <div 
          className="bg-[#30a84b] content-stretch flex gap-[4px] h-[36px] items-center justify-center p-[12px] relative rounded-[6px] shrink-0 cursor-pointer hover:bg-[#288e3e] transition-colors" 
          data-name="Primary - Sm"
          onClick={onStartCreating}
        >
          <p className="font-sans font-semibold leading-[normal] relative shrink-0 text-[14px] text-nowrap text-white" style={{ fontVariationSettings: "'opsz' 14, 'wdth' 100" }}>
            Start Creating
          </p>
        </div>
      </div>
    </div>
  );
}

